/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

import { GREAT_WHITE } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import Small from 'UIComponents/elements/Small';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RECURRING } from 'self-service-api/constants/ChargeTypes';
import styled, { css } from 'styled-components';
import { BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { useAppSelector } from '../../../reducers';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { calculatedPriceSelector } from '../../../selectors/PricingSelectors';
import { hasMaxProductQuantityInProductInventorySelector, hasProductVersionInProductInventorySelector, productsFromProductInventoryQuantitySelector } from '../../../selectors/ProductInventorySelectors';
import { billingNameKeySelector, productForSkuIdSelector, productVersionSelector } from '../../../selectors/ProductsSelectors';
import { purchaseMotionsSelector } from '../../../selectors/PurchaseMotionSelectors';
import PriceDisplay from '../../common/pricing/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPrice = styled.div.withConfig({
  displayName: "ExpandableChecklistItem__StyledPrice",
  componentId: "ldbhld-0"
})(["font-size:14px;font-weight:600;margin-top:8px;margin-bottom:6px;"]);
const StyledStepperWrapper = styled(UIFormControl).withConfig({
  displayName: "ExpandableChecklistItem__StyledStepperWrapper",
  componentId: "ldbhld-1"
})(["margin-left:16px;"]);
const StyledStepper = styled(UIStepperInput).withConfig({
  displayName: "ExpandableChecklistItem__StyledStepper",
  componentId: "ldbhld-2"
})(["width:100px;"]);
const Bold = styled.b.withConfig({
  displayName: "ExpandableChecklistItem__Bold",
  componentId: "ldbhld-3"
})(["font-size:14px;"]);
const SelectableBox = styled(UISelectableBox).withConfig({
  displayName: "ExpandableChecklistItem__SelectableBox",
  componentId: "ldbhld-4"
})(["&&&{width:100%;border-radius:0;&:hover{z-index:8;}", ";", ";}"], ({
  disabled
}) => disabled && css(["border-color:", " !important;font-weight:400;"], GREAT_WHITE), ({
  selected
}) => selected && css(["background-color:inherit;z-index:7;"]));
const ExpandableChecklistItem = ({
  skuId,
  selectedQuantity,
  onSelectedChange,
  use,
  queryParamTerm
}) => {
  const ownedQuantity = useAppSelector(state => productsFromProductInventoryQuantitySelector(state, {
    skuId
  }));
  const apiName = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }).apiName);
  useEffect(() => {
    if (selectedQuantity < ownedQuantity) {
      onSelectedChange({
        value: ownedQuantity,
        skuId,
        apiName,
        previousValue: selectedQuantity
      });
    }
  }, [selectedQuantity, ownedQuantity]);
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  const currencyCode = useSelector(activeCurrencySelector);
  const isRecurring = useAppSelector(state => {
    const {
      chargeType
    } = productForSkuIdSelector(state, {
      skuId
    });
    return chargeType === RECURRING;
  });
  const quantifiable = useAppSelector(state => {
    const productVersion = productVersionSelector(state, {
      skuId
    });
    return productVersion.quantifiable;
  });
  const singleUnitPrice = useAppSelector(state => {
    const pricingInfo = calculatedPriceSelector(state, {
      productConfigurations: [createProductConfig({
        skuId
      })],
      queryParamTerm
    });
    return isRecurring ? pricingInfo.monthly.calculatedPrice : pricingInfo.oneTimeFee.calculatedPrice;
  });
  const isTouchlessEligible = useAppSelector(state => purchaseMotionsSelector(state, {
    location: MERCH_CARD,
    skuId
  })).includes(BUY_TOUCHLESS);
  const ownsProduct = useAppSelector(state => hasProductVersionInProductInventorySelector(state, {
    skuId
  }));
  const ownsMaxQuantityOfProduct = useAppSelector(state => hasMaxProductQuantityInProductInventorySelector(state, {
    skuId
  }));
  const maxTouchlessPurchasableQuantity = useAppSelector(state => {
    const productVersion = productVersionSelector(state, {
      skuId
    });
    return productVersion.maxTouchlessPurchasableQuantity;
  });
  const limit = maxTouchlessPurchasableQuantity === null ? Infinity : maxTouchlessPurchasableQuantity || 1;
  const canBuyMultiple = quantifiable && limit > 1;
  const disableTile = canBuyMultiple ? ownsMaxQuantityOfProduct : ownsProduct;
  const checked = selectedQuantity > ownedQuantity;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: canBuyMultiple ? 'planBuilder.addonsAndServices.addons.disabledTooltip.canOwnMultiple' : 'planBuilder.addonsAndServices.addons.disabledTooltip.canOwnOne'
    }),
    disabled: !disableTile,
    children: /*#__PURE__*/_jsx(SelectableBox, {
      className: "text-left",
      type: "checkbox",
      selectionMarkLocation: "top-right",
      disabled: disableTile,
      selected: checked,
      onSelectedChange: () => {
        onSelectedChange({
          value: checked ? ownedQuantity : ownedQuantity + 1,
          skuId,
          apiName,
          previousValue: checked ? selectedQuantity : ownedQuantity
        });
      },
      "data-selenium-class": `${use}-checklist-item`,
      "data-selected": checked,
      "data-touchless-eligible": isTouchlessEligible,
      "data-api-name": apiName,
      children: /*#__PURE__*/_jsxs("div", {
        className: "m-left-1",
        children: [/*#__PURE__*/_jsx(Bold, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `pricing-pages.products.${billingNameKey}.title`
          })
        }), /*#__PURE__*/_jsxs(UIFlex, {
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs(StyledPrice, {
              children: [/*#__PURE__*/_jsx(PriceDisplay, {
                price: singleUnitPrice,
                currencyCode: currencyCode
              }), isRecurring ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "planBuilder.priceDisplay.perMonth"
              }) : /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  className: "m-left-1",
                  message: "pricingPage.notes.oneTimeFeeParentheses"
                })
              })]
            }), /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx("p", {
                className: "m-bottom-2",
                children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: `pricing-pages.products.${billingNameKey}.paragraph`
                })
              })
            })]
          }), canBuyMultiple && /*#__PURE__*/_jsx(StyledStepperWrapper, {
            label: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("span", {
                className: "sr-only",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `pricing-pages.products.${billingNameKey}.title`
                })
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "planBuilder.productPages.quantity"
              })]
            })
            // @ts-expect-error UIFormControl does not define the onClick and onMouseDown types
            // Prevent click from changing selected state
            ,
            onClick: evt => {
              evt.stopPropagation();
            }
            // Prevent the active styles from taking effect when interacting with stepper
            ,
            onMouseDown: evt => {
              evt.stopPropagation();
            },
            children: /*#__PURE__*/_jsx(StyledStepper, {
              disabled: disableTile,
              stepSize: 1,
              onChange: evt => {
                const value = evt.target.value;
                onSelectedChange({
                  value,
                  skuId,
                  apiName,
                  previousValue: selectedQuantity
                });
              },
              value: selectedQuantity,
              min: ownedQuantity,
              max: limit
            })
          })]
        })]
      })
    })
  });
};
export default ExpandableChecklistItem;